import {Card} from './Card'
const data = require('../../config/cards.json')['Cafe']

export default class Cafe extends Card {
	constructor() {
		super(data)
	}

	/**
	 * Give one coin to the other
	 */
	activate(other) {
		const take = Math.min(1, other.coins) // at most

		this.owner.coins += take
		other.coins -= take
	}

	/**
	 * The real name
	 * @return {string}
	 */
	get name () { return "Café" }
}
